module.exports = __webpack_public_path__ + "static/media/orderDetailsEircodeIcon.2e28bfc0.svg";